import { Component, OnInit, Input } from '@angular/core';
import { AdminService } from 'app/modules/admin/services/admin.service';
import { QuotaHistory } from 'app/modules/domain/models/quotaHistory';
import * as moment from 'moment';
import { ChartType, ChartOptions } from 'chart.js';
import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-credit-usage',
  templateUrl: './credit-usage.component.html',
  styleUrls: ['./credit-usage.component.scss']
})
export class CreditUsageComponent implements OnInit {
  private _users;

  public chartColors: Array<any> = [
    {
      backgroundColor: 'dodgerblue',
      borderColor: 'dodgerblue'
    },
    {
      backgroundColor: '#FF8C42',
      borderColor: '#FF8C42',
    }];

  get users(): any {
    return this._users;
  }

  @Input()
  set users(val: any) {
    this._users = val;
    if (this._users.length) {
      this.getQuotaForCompany(this.users[0].id);
    }
  }

  @Input() companyId: string;

  public barChartLabels: string[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        stacked: true
      }],
      yAxes: [{
        stacked: true,
        ticks: {
          min: 0, // it is for ignoring negative step.
          beginAtZero: true,
          callback: (value) => {
              if (Math.floor(Number(value)) === value) {
                  return value;
              }
          }
      }
      }]
    }
  };
  public barChartData: any[] = [
    {
      data: [],
      label: this.translate.instant('AVAILABLE_QUOTA')
    },
    {
      data: [],
      label: this.translate.instant('USER_RESERVED_QUOATA')
    }
  ];

  constructor(private adminService: AdminService,
              private translate: TranslateService) { }

  ngOnInit() {

  }

  private getQuotaForCompany(userId: string): void {
    this.adminService.getQuotaHistory(this.companyId, userId, moment().format('YYYY-MM-DD'), moment().add(31, 'days').format('YYYY-MM-DD'))
      .subscribe((quotaHistory: QuotaHistory[]) => {
        this.barChartLabels = [];
        this.barChartData[0].data = [];
        this.barChartData[1].data = [];

        quotaHistory.forEach(history => {
          this.barChartLabels.push(moment(history.date).format('DD/MM'));
          (this.barChartData[0].data as number[]).push(history.limit - history.usage);
          (this.barChartData[1].data as number[]).push(history.usage);
        });
      });
  }

  public updateSelectedUser(userId: string): void {
    this.getQuotaForCompany(userId);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/shared/credit-usage/credit-usage.component.ts